import { InfoConfirmComponent } from "./component/info-confirm/info-confirm.component";

export abstract class IGlobalComponent {
  abstract openInfoAlert(message: string, param?: { title?: string, afterClose?: () => void }): InfoConfirmComponent;
  abstract openInfoConfirm(message: string, param?: { title?: string, afterConfirm?: () => void, afterClose?: () => void }): InfoConfirmComponent;
  abstract openErrorAlert(message: string, param?: { title?: string, afterClose?: () => void, showCopyTip?: boolean }): InfoConfirmComponent;
  /** 實作顯示progressBar, GlobalComponentService 會調用這個方法 */
  abstract openIndeterminateProgressBar(): void;
  /** 實作關閉progressBar, GlobalComponentService 會調用這個方法 */
  abstract closeIndeterminateProgressBar(): void;
}
